import ExtendedFilter from '@shared/components/filters/extended-filter/extended-filter.vue';
import StdFilter from '@shared/components/filters/std-filter/std-filter.vue';
import EntityFormProvider from '@shared/components/forms/auto-form/entity-form-provider/etity-form-provider.vue';
import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import { FormConfig, FormFieldConfig } from '@shared/interfaces/config';
import { CustomFilter } from '@tools/interfaces/custom-filter';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

@Component({
  name: 'bpc-custom-filter-form',
  components: {
    'bpc-std-form': StdForm,
    'bpc-extended-filter': ExtendedFilter,
  },
})
export default class CustomFilterForm extends Vue {
  $refs: {
    // resourceForm: InstanceType<typeof ResourceForm> & { saveEntity(): void };
    stdForm: InstanceType<typeof StdForm> & {
      saveEntity(): void;
      formModel: CustomFilter;
      onDeleteMediaFile(): void;
      searchEntity(): void;
      extraData: string | AnyEntity;
      formProvider: EntityFormProvider;
    };
    extendedFilter: InstanceType<typeof StdFilter> & {
      setFilterModel(filterModel): void;
      filterModel: AnyEntity;
    };
  };
  @Prop(String) readonly entity: string;
  @Prop([String, Number]) readonly entityId: string | number;
  @Prop([Object]) readonly value: CustomFilter;
  @Prop({ type: String, default: 'default' }) formConfigName: string;
  @Prop({ type: Boolean, default: false }) disabled: string;
  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  readonly extraData: Record<string, any>;

  public formModel: CustomFilter = null;
  public configLoaded: boolean = false;
  public config: FormConfig = null;

  get selectedEntity() {
    return this.formModel?.entity;
  }

  get filterEntityType() {
    if (this.selectedEntity) {
      if (this.selectedEntity === 'archive_of_activities') {
        return 'bpc_activity';
      }
      if (this.selectedEntity.includes('archive_of')) {
        return this.selectedEntity.replace('archive_of_', '');
      }
      return this.selectedEntity;
    }
    return null;
  }

  get fieldsObject(): Record<string, FormFieldConfig> {
    return this.config?.fields || {};
  }

  get fieldsConfig(): FormFieldConfig[] {
    return Object.values(this.fieldsObject) || [];
  }

  onFormSaved(e) {
    this.$emit('entity-saved', e);
  }
  onSavingEntity(event) {
    this.$emit('saving-entity', event);
  }
  deleteMediaFile(mediaId) {
    this.$emit('delete-media-file', { mediaId: mediaId, entityId: this.entityId });
  }
  saveEntity() {
    const filterModel = this.$refs.extendedFilter.filterModel;
    const newModel = {
      ...this.$refs.stdForm.formModel,
      filters: filterModel,
    };
    console.log('newModel', newModel);
    this.$refs.stdForm.formModel = newModel;
    this.$refs.stdForm.saveEntity();
  }
  onConfigLoaded(event) {
    this.configLoaded = true;
    this.config = event;
    this.$emit('config-loaded', event);
  }

  // mounted() {
  //   this.$root.$on('changePostType', val => {
  //     console.log('changePostType', val);
  //     this.formModel.entity = val;
  //   });
  // }

  // destroyed() {
  //   this.$root.$off('changePostType');
  // }
  // async updateModelFiltersProp() {
  //   this.$bpcApi.get;
  // }

  @Watch('formModel', { immediate: true, deep: true })
  onFormModelChange() {
    this.$emit('input', this.formModel);
  }
  // @Watch('selectedEntity')
  // onSelectedEntityChange() {
  //   this.updateModelFiltersProp();
  // }
}
